import React from "react";
import { useTranslation } from "react-i18next";

// Matches Diamond-PO-Prototype-v3.html's History panel in docDetail() exactly (events reversed,
// newest first; EventType "PARTIAL_SHIP" -> "Partial ship"; fmtDT = date + time, line 561).

const titleCase = (eventType) =>
  eventType
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/^./, (c) => c.toUpperCase());

const fmtDT = (iso) =>
  iso
    ? new Date(iso).toLocaleDateString() + " " + new Date(iso).toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" })
    : "—";

export const HistoryTimeline = ({ events, retailerDealerId, retailerName, supplierDealerId, supplierName }) => {
  const { t } = useTranslation();
  const actorName = (actorDealerId) => (String(actorDealerId) === String(retailerDealerId) ? retailerName : supplierName);

  return (
    <div style={{ background: "#fff", border: "1px solid #eee", borderRadius: 8, padding: 16 }}>
      <h3 style={{ marginTop: 0 }}>{t("History")}</h3>
      {events
        .slice()
        .reverse()
        .map((e, i) => (
          <div key={e.OrderEventID || i} style={{ padding: "8px 0", borderTop: i === 0 ? "none" : "1px solid #f3f3f3" }}>
            <b>
              {titleCase(e.EventType)} · {actorName(e.ActorDealerID)}
            </b>
            <div style={{ color: "#79838f", fontSize: 12.5 }}>
              {fmtDT(e.OccurredUtc)}
              {e.Detail ? ` — ${e.Detail}` : ""}
            </div>
          </div>
        ))}
    </div>
  );
};

export default HistoryTimeline;
